import { render, staticRenderFns } from "./WaiterSetting.vue?vue&type=template&id=879bee30&scoped=true&lang=pug"
import script from "./WaiterSetting.vue?vue&type=script&lang=ts"
export * from "./WaiterSetting.vue?vue&type=script&lang=ts"
import style0 from "./WaiterSetting.vue?vue&type=style&index=0&id=879bee30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879bee30",
  null
  
)

export default component.exports